import React from 'react'
import {
  Container,
  TextTitle,
  TextBody,
  HtmlContent
} from '@pmi/pmi-iqos-ds-react'
import { LazyImage } from '@pmi/pmi-iqos-shared-react'

const CheckoutCartItem = ({ item, translations, position }) => {
  const hasPromotionalBanner = cartItem => {
    return cartItem.products.some(product => product.promotionBanners.length)
  }

  return (
    <Container
      py="8"
      divider={position === 'last' ? null : Container.dividers.bottom}>
      {item.products.map((product, index) => (
        <Container
          key={index}
          fullWidth
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.start}>
          <Container
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}
            pr="2"
            width="3/12">
            {product.image && <LazyImage src={product.image} height="16" />}
          </Container>

          <Container
            fullWidth
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.between}
            width="9/12">
            <Container fullWidth pr="8">
              <TextTitle
                heading={TextTitle.headings.h6}
                data-testing="Cart_TextTitle_ProductName">
                {product.name}
              </TextTitle>
              <TextBody size={TextBody.sizes.xs}>
                {translations.tk_qty + ' ' + product.amount}
              </TextBody>
            </Container>
          </Container>
        </Container>
      ))}
      {hasPromotionalBanner(item) && (
        <Container pt="4" px="6">
          {item.products.map(product =>
            product.promotionBanners.map((promotionBanner, index) => (
              <Container pt="4" key={index}>
                <HtmlContent content={promotionBanner} />
              </Container>
            ))
          )}
        </Container>
      )}
    </Container>
  )
}

export default CheckoutCartItem
